import { formatDateTime } from "@repo/utils/date";

export const DateCell = ({ children }: { children?: string | Date | null }) => {
  if (!children) return null;
  return formatDateTime(children);
};
